export default "__VITE_ASSET__Bb_0AlgH__"